'use client'

import Image from 'next/image'
import { useParams } from 'next/navigation'
import { useTexts } from '@/contexts/LanguageContext'
import CertificationBadge from '../../certifications/components/CertificationBadge'
import { useCertifications } from '../../certifications/useCertifications'
import { TRUST_CENTER_SECTIONS, trustCenterPath } from '../../utils'
import SectionHeader from './SectionHeader'

export default function CertificationsOverview() {
  const { CERTIFICATIONS } = useTexts().PUBLIC_TRUST_CENTER.OVERVIEW
  const { orgToken } = useParams<{ orgToken: string }>()
  const certifications = useCertifications()
  if (certifications.length === 0) return null
  return (
    <section className="flex flex-col gap-3.5 py-8">
      <SectionHeader
        title={CERTIFICATIONS.TITLE}
        link={{
          href: trustCenterPath(orgToken, TRUST_CENTER_SECTIONS.CERTIFICATIONS),
          label: CERTIFICATIONS.VIEW_DETAILS,
        }}
      />
      <div className="grid gap-4 md:grid-cols-3">
        {certifications.map((certification) => (
          <div
            key={certification.standard}
            className="flex items-center gap-3.5 rounded border border-trust-center-border p-3.5"
          >
            <Image src={certification.logo} alt="" width={36} height={36} className="size-9 object-contain" />
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span className="text-base font-semibold">{certification.name}</span>
              <span className="truncate text-xs text-trust-center-muted">{certification.description}</span>
            </span>
            <CertificationBadge />
          </div>
        ))}
      </div>
    </section>
  )
}
